module.exports = new __parcel__URL__("3ddrawing.c77ae6fb.png").toString();